module.exports = __webpack_public_path__ + "img/Coke_Empanada.327e7650.gif";